<template>
    <app-layout>
        <Head>
            <title>Kontosuche</title>
        </Head>

        <template v-slot:overline>
            <translate>Kontosuche</translate>
        </template>

        <template v-slot:headline>
            <translate>Über die Suche in der Tabelle können Sie die Daten filtern.</translate>
        </template>

        <div class="row">
            <div class="col">
                <card>
                    <card-header>
                        <card-title>Suche</card-title>
                    </card-header>
                    <card-content>
                        <form @submit.prevent="submit">
                            <form-inline>
                                <form-input id="searchphrase" name="searchphrase"
                                            :placeholder="this.$gettext('Suchbegriff')" v-model="form.searchphrase"
                                            :error="form.errors.searchphrase"/>
                                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                    <translate>Suchen</translate>
                                </form-button>
                            </form-inline>
                        </form>
                    </card-content>
                </card>
                <card v-if="hasSearchResult">
                    <card-header>
                        <card-overline>
                            <translate>Suchergebnis</translate>
                        </card-overline>
                    </card-header>
                    <card-content>
                        <table class="table table--stripped table--td-top">
                            <thead>
                            <tr>
                                <th>
                                    <translate>PF-Nr.</translate>
                                </th>
                                <th>
                                    <translate>Projekttitel</translate>
                                </th>
                                <th>
                                    <translate>Artikelnummer</translate>
                                </th>
                                <th>
                                    <translate>Anfragenummer</translate>
                                </th>
                                <th>
                                    <translate>Bestellnummer</translate>
                                </th>
                                <th class="text-right">
                                    <translate>Stück</translate>
                                </th>
                                <th class="text-right">
                                    <translate>Wunschliefertermin</translate>
                                </th>
                                <th class="text-right">
                                    <translate>Nettopreis</translate>
                                </th>
                                <th class="text-right">
                                    <translate>Liefertermin</translate>
                                </th>
                                <th class="text-right">
                                    <translate>Bestelldatum</translate>
                                </th>
                                <th  class="text-center">
                                    <translate>Status</translate>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="askForQuote in searchResultTable" :key="askForQuote.index">
                                <td>
                                    <Link
                                        :href="$$route('component', {'askForQuote': askForQuote.id} )">
                                        {{ askForQuote.pfnumber }}
                                    </Link>
                                </td>
                                <td>
                                    {{ askForQuote.project_name }}
                                </td>
                                <td>
                                    {{ askForQuote.internal_article_number }}
                                </td>
                                <td>
                                    {{ askForQuote.internal_ask_number }}
                                </td>
                                <td>
                                    {{ askForQuote.internal_order_number }}
                                </td>
                                <td v-html="askForQuote.amount"  class="text-right"></td>
                                <td class="text-right">
                                    {{ askForQuote.delivery_date_string }}
                                </td>
                                <td v-html="askForQuote.net_price" class="text-right"></td>
                                <td class="text-right">
                                    {{ askForQuote.order_delivery_date_string }}
                                </td>
                                <td class="text-right">
                                    {{ askForQuote.order_created_at_string }}
                                </td>
                                <td class="text-center">
                                    <translate>{{ askForQuote.status_string }}</translate>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </card-content>
                </card>
                <card v-if="!hasSearchResult && hasSearchphrase">
                    <card-header>
                        <card-overline>
                            <translate>Suchergebnis</translate>
                        </card-overline>
                    </card-header>
                    <card-content>
                        <table class="table table--stripped">
                            <thead>
                            <tr>
                                <th>
                                    <translate>PF-Nr.</translate>
                                </th>
                                <th>
                                    <translate>Projekttitel</translate>
                                </th>
                                <th>
                                    <translate>Stück</translate>
                                </th>
                                <th>
                                    <translate>Wunschliefertermin</translate>
                                </th>
                                <th>
                                    <translate>Nettopreis</translate>
                                </th>
                                <th>
                                    <translate>Liefertermin</translate>
                                </th>
                                <th>
                                    <translate>Bestelldatum</translate>
                                </th>
                                <th>
                                    <translate>Status</translate>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colspan="8" class="text-center">
                                    <strong>
                                        <translate>keine Suchergebnis für</translate>
                                        {{ form.searchphrase }}
                                    </strong>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </card-content>
                </card>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormInline from '@partfactory/Shared/Form/FormInline';
import CardOverline from '@partfactory/Shared/Card/CardOverline';

export default {
    name: 'Quotes',
    components: {
        CardOverline,
        FormInline,
        FormButton,
        FormInput,
        CardTitle,
        CardHeader, CardContent, Card, AppLayout
    },
    props: {
        searchphrase: String,
        searchResult: Object,
    },
    data() {
        const form = useForm({
            searchphrase: this?.searchphrase,
        });

        return {form};
    },
    computed: {
        hasSearchResult() {
            return !!this.searchResult?.length;
        },
        hasSearchphrase() {
            return !!this.searchphrase;
        },
        searchResultTable() {
            let searchResultTable = this.searchResult;

            searchResultTable.forEach((askForQuote) => {
                if (askForQuote?.producer_order) {
                    askForQuote.amount = askForQuote.producer_order.amount;
                } else if (askForQuote?.client_offers?.length > 0){
                    let lotQty = [];
                    askForQuote.client_offers.map((offer) => {
                        lotQty.push(offer.amount);
                    });
                    askForQuote.amount = lotQty.filter(lot => lot !== null).join('<br>');

                } else {
                    let lotQty = [];
                    lotQty.push(askForQuote.lotqty_1, askForQuote.lotqty_2, askForQuote.lotqty_3, askForQuote.lotqty_4);
                    askForQuote.amount = lotQty.filter(lot => lot !== null).join('<br>');
                }

                if (askForQuote?.client_order) {
                    askForQuote.net_price = this.$currency(askForQuote?.client_order?.client_offer?.net_price);
                } else if (askForQuote?.client_offers?.length > 0) {
                    let netPrice = [];
                    askForQuote.client_offers.map((offer) => {
                        netPrice.push(offer.net_price);
                    });
                    askForQuote.net_price = netPrice.map(lot => {
                        return lot ? this.$currency(lot) : '';
                    }).join('<br>');
                }




                askForQuote.delivery_date_string = this.$date(askForQuote?.delivery_date);

                askForQuote.order_delivery_date_string = askForQuote?.client_order?.delivery_at ? this.$date(askForQuote?.client_order?.delivery_at) : '';

                askForQuote.order_created_at_string = askForQuote?.client_order?.created_at ? this.$date(askForQuote?.client_order?.created_at) : '';

                askForQuote.status_string = this.$readableStatusClient(askForQuote.status);

                return askForQuote;
            });

            return searchResultTable;
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('search.post'));
        },
    },
};
</script>
